export default __webpack_public_path__ + "static/media/LogoText.d687b939.svg";